import TrackingService from "./tracking_service";

export default class PromoShopPromo {

    constructor() {
        this.trackingService = new TrackingService();
    }

    trackClick(clickableItem, position, filledSlots, promoType) {
        const container = this.findParentContainer(clickableItem, promoType);
        const destinationUrl = this.getDestinationUrl(clickableItem);
        const featureOrder = this.getFeatureOrder(container);
        const featureIndex = this.getFeatureIndex(container);
        const source = clickableItem.parentElement.getAttribute('data-image-source-type') || 'manual'

        this.trackingService.sendClickTrackingEvent(promoType, destinationUrl, featureOrder, featureIndex, filledSlots, position + 1, source);
    }

    getDestinationUrl(item) {
        return item.getAttribute('href');
    }

    trackInitialViewLargeShopPromo(container) {
        const promoType = this.getPromoType(container);
        const destinationUrls = this.getAllDestinationUrls(container, promoType);
        const featureOrder = this.getFeatureOrder(container);
        const sourceUrls = this.getSourceUrls(container, promoType);
        const filledSlots = sourceUrls.length;
        const featureIndex = this.getFeatureIndex(container);

        //small shop promos are tracked via cinema
        if (container.getAttribute("data-isslidingcinemaenabled") === "false") {
            this.trackingService.sendViewTrackingEvent(promoType, destinationUrls, featureOrder, featureIndex, filledSlots, sourceUrls);
        } else {
            let firstSlideContainer = container.querySelectorAll('.promo_shoppromo-large--item')[0];
            firstSlideContainer.setAttribute("data-slidetracked", 'true');
            this.trackingService.sendViewTrackingEvent(promoType, [destinationUrls[0]], featureOrder, featureIndex, filledSlots, [sourceUrls[0]]);
        }
    }

    trackInitialViewSmallShopPromo(container, lastIndex) {
        const promoType = this.getPromoType(container);
        const destinationUrls = this.getAllDestinationUrls(container, promoType, 0, lastIndex);
        const featureOrder = this.getFeatureOrder(container);
        const sourceUrls = this.getSourceUrls(container, promoType, 0, lastIndex);
        const filledSlots = this.getSourceUrls(container, promoType).length;
        const featureIndex = this.getFeatureIndex(container);

        this.setTileTracked(container, lastIndex);

        this.trackingService.sendViewTrackingEvent(promoType, destinationUrls, featureOrder, featureIndex, filledSlots, sourceUrls);
    }

    trackSlide(container, slideIndex, movementType) {
        const promoType = this.getPromoType(container);
        const destinationUrls = this.getAllDestinationUrls(container);
        const featureOrder = this.getFeatureOrder(container);
        const sourceUrls = this.getSourceUrls(container);
        const featureIndex = this.getFeatureIndex(container);

        //decrease filled slots by 2 due to infinite slider buffer
        const filledSlots = sourceUrls.length - 2;
        this.trackingService.sendViewTrackingEventHidden(promoType, destinationUrls[slideIndex], featureOrder, featureIndex, filledSlots, sourceUrls[slideIndex], slideIndex, movementType);
    }

    trackViewOnCinemaMovement(container, startIndex, endIndexExclusive) {
        const promoType = this.getPromoType(container);
        const destinationUrls = this.getAllDestinationUrls(container, promoType, startIndex, endIndexExclusive);
        const featureOrder = this.getFeatureOrder(container);
        const sourceUrls = this.getSourceUrls(container, promoType, startIndex, endIndexExclusive);
        const filledSlots = this.getSourceUrls(container, promoType).length;
        const featureIndex = this.getFeatureIndex(container);
        let allTiles = container.querySelectorAll('.promo_shoppromo-small--tile');
        Array.from(allTiles)
            .slice(startIndex, endIndexExclusive)
            .forEach((tile, index) => {
                if (tile.getAttribute("data-tracked") !== 'true') {
                    tile.setAttribute("data-tracked", 'true');
                    const slideIndex = parseInt(tile.getAttribute("data-index")) + 1;
                    this.trackingService.sendViewTrackingEventHidden(promoType, destinationUrls[index], featureOrder, featureIndex, filledSlots, sourceUrls[index], slideIndex);
                }
            });
    }

    trackCinemaMovementType(container, movementType) {
        const promoType = this.getPromoType(container);
        const featureOrder = this.getFeatureOrder(container);
        const filledSlots = this.getSourceUrls(container, promoType).length;
        const featureIndex = this.getFeatureIndex(container);
        this.trackingService.sendMovementTrackingEventHidden(promoType, featureOrder, featureIndex, filledSlots, movementType);
    }

    getPromoType(container) {
        return container.getAttribute("data-promo-type");
    }

    getAllDestinationUrls(container, promoType, startIndex, lastIndex) {
        const selector = promoType === 'ShopPromotionSmall' ? '.promo_shoppromo-small--tile a' : '.promo_shoppromo-large--image-container a';
        const trackingDivs = container.querySelectorAll(selector);

        startIndex = startIndex || 0;
        lastIndex = lastIndex || trackingDivs.length;

        return [].map
            .call(trackingDivs, div => div.getAttribute('href'))
            .slice(startIndex, lastIndex);
    }

    getFeatureOrder(container) {
        return parseInt(container.parentElement.getAttribute('data-feature-order'), 0);
    }

    getFeatureIndex(container) {
        return parseInt(container.getAttribute('data-feature-index'), 0);
    }

    getSourceUrls(container, promoType, startIndex, lastIndex) {
        const selector = promoType === 'ShopPromotionSmall' ? '.promo_shoppromo-small--tile' : '.promo_shoppromo-large--image-container';
        const shoppromoContainer = container.querySelectorAll(selector);

        startIndex = startIndex || 0;
        lastIndex = lastIndex || shoppromoContainer.length;

        return [].map
            .call(shoppromoContainer, shoppromoTile => shoppromoTile.getAttribute('data-image-source-type') || 'manual')
            .slice(startIndex, lastIndex);
    }

    findParentContainer(elem, promoType) {
        const className = promoType === 'ShopPromotionSmall' ? 'promo_shoppromo-small--container' : 'promo_shoppromo-large--container';
        while (!elem.classList.contains(className) && (elem = elem.parentElement));
        return elem;
    }

    setTileTracked(container, lastIndex) {
        const tiles = container.querySelectorAll('.promo_shoppromo-small--tile');
        Array.from(tiles)
            .slice(0, lastIndex)
            .forEach(tile => tile.setAttribute("data-tracked", 'true'))
    }

    static loadImages(container) {
        const promoImages = container.querySelectorAll('.promo_shoppromo-large--image');
        const sources = container.querySelectorAll('.promo_shoppromo-large--picture source');
        const logos = container.querySelectorAll('.promo_shoppromo-large--logo');

        //Replace placeholder images and picture sources with real ones
        for (let i = 0; i < promoImages.length; i++) {
            if (promoImages[i].getAttribute('data-src')) {
                promoImages[i].setAttribute('src', promoImages[i].getAttribute('data-src'));
            }
        }
        for (let i = 0; i < sources.length; i++) {
            if (sources[i].getAttribute('data-srcset')) {
                sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset'));
            }
        }
        for (let i = 0; i < logos.length; i++) {
            if (logos[i].getAttribute('data-src')) {
                logos[i].setAttribute('src', logos[i].getAttribute('data-src'));
            }
        }
    }
}
